// Zentrale Regel: Welche Termine sind für Mitglieder (Pro) kostenlos?
//
// Bisher war diese Prüfung in mehreren Seiten dupliziert (TerminCheckout,
// TerminLandingPage, Termine, StudentTermine) und fehlte im Backend komplett —
// dadurch konnte ein zahlendes Mitglied eine 49-€-Rechnung für ein
// Themenwebinar erhalten (Ticket Ramona Behr, 10.09.2026).

export interface TerminFreeInput {
  typ: string | null | undefined;
  zugangstyp?: string | null;
  preisNormal?: number | null;
  isMember: boolean;
}

/** Liederwerkstatt-Reihen (Gitarrissimo, Vokalissimo, Ukulissimo). */
export function isLiederwerkstattTyp(typ: string | null | undefined): boolean {
  const t = (typ ?? "").toLowerCase();
  return (
    t.includes("liederwerkstatt") ||
    t.includes("gitarrissimo") ||
    t.includes("vokalissimo") ||
    t.includes("ukulissimo")
  );
}

/** Themenwebinare. */
export function isThemenwebinarTyp(typ: string | null | undefined): boolean {
  const t = (typ ?? "").toLowerCase();
  return typ === "Themenwebinare" || t.includes("themenwebinar");
}

/** Termin-Typen, die für Mitglieder grundsätzlich kostenlos sind. */
export function isMemberFreeTerminTyp(typ: string | null | undefined): boolean {
  return isLiederwerkstattTyp(typ) || isThemenwebinarTyp(typ);
}

/** Ist dieser Termin für den aktuellen Nutzer kostenlos? */
export function isTerminFreeForUser(input: TerminFreeInput): boolean {
  if (input.zugangstyp === "öffentlich_kostenlos") return true;
  if (!input.preisNormal) return true;
  return input.isMember && isMemberFreeTerminTyp(input.typ);
}
